import { render, staticRenderFns } from "./CmgCheckoutCustomerPaymentMethods.vue?vue&type=template&id=3fdc39e2&scoped=true&lang=pug"
import script from "./cmg-checkout-customer-payment-methods.ts?vue&type=script&lang=ts&external"
export * from "./cmg-checkout-customer-payment-methods.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgCheckoutCustomerPaymentMethods.vue?vue&type=style&index=0&id=3fdc39e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdc39e2",
  null
  
)

export default component.exports